import { Injectable, type Provider } from '@angular/core';

import { ok, type ApiResult } from '../../../core/models/api-result';
import type {
  StepChallenge,
  StepLeaderboard,
} from '../../../core/services/community-integrations.service';
import { HubChallengesService } from './hub-challenges.service';

const toDay = (now: Date, days: number): string => {
  const at = new Date(now);
  at.setUTCDate(at.getUTCDate() + days);
  return at.toISOString().slice(0, 10);
};

/**
 * HUB CHALLENGES WITHOUT A SESSION. Coffee Club has a running challenge and
 * one coming up; every other hub has none, so the empty state is reviewable.
 * Small enough to sit in the eager bundle with no fixture import.
 */
@Injectable()
export class HubChallengesPreviewService extends HubChallengesService {
  private readonly now = new Date();

  private challengesFor(hubId: string): StepChallenge[] {
    if (hubId !== 'coffee') return [];
    return [
      {
        id: 'ch-october',
        communityId: 'coffee',
        name: 'October step-up',
        description: 'Walk to the good coffee. 8,000 a day.',
        startDate: toDay(this.now, -6),
        endDate: toDay(this.now, 8),
        dailyGoalSteps: 8000,
        themeKey: 'strider',
        participantCount: 14,
        teamTotalSteps: 1_204_331,
        status: 'active',
        joined: true,
        myTotalSteps: 42_118,
        myRank: 6,
        canManage: false,
      },
      {
        id: 'ch-winter',
        communityId: 'coffee',
        name: 'Winter commute',
        startDate: toDay(this.now, 20),
        endDate: toDay(this.now, 34),
        participantCount: 3,
        status: 'upcoming',
        joined: false,
        canManage: false,
      },
    ];
  }

  protected override async fetchChallenges(hubId: string): Promise<ApiResult<StepChallenge[] | null>> {
    return ok(this.challengesFor(hubId));
  }

  protected override async fetchBoard(challengeId: string): Promise<ApiResult<StepLeaderboard | null>> {
    const challenge = this.challengesFor('coffee').find(c => c.id === challengeId);
    if (!challenge) return ok(null);
    const names = ['Sofia Marin', 'Dean Okafor', 'Priya Raman', 'Callum Rees', 'Aiko Tanaka'];
    const entries = names.map((name, i) => ({
      rank: i + 1,
      userId: `p${i}`,
      name,
      totalSteps: 96_000 - i * 9_500,
      activeDays: 6,
      isViewer: false,
    }));
    return ok({
      challenge,
      entries,
      myEntry: { rank: 6, userId: 'preview-viewer', name: 'You', totalSteps: 42_118, activeDays: 5, isViewer: true },
    });
  }
}

export const HUB_CHALLENGES_PREVIEW_PROVIDER: Provider = {
  provide: HubChallengesService,
  useClass: HubChallengesPreviewService,
};
